// extracted by mini-css-extract-plugin
export default {"Attachments":"styles_Attachments__x0I4L"};